import { a, img, iframe, svg, path, pre, circle } from '../tags';

// READ THIS: https://github.com/apostrophecms/sanitize-html?tab=readme-ov-file#what-if-i-want-to-maintain-the-original-case-for-svg-elements-and-attributes
// TODO: remove this legacyAttributes when the content is full migrated
const legacyAttributes = [ '_ng*' ];
const attributes = {
    '*': [ 'data-*', 'aria-*', 'class', 'id', 'itemprop', 'style', 'role', 'viewbox', 'colspan', 'rowspan', ...legacyAttributes ],
    a: a.allowedAttributes,
    img: img.allowedAttributes,
    iframe: iframe.allowedAttributes,
    svg: svg.allowedAttributes,
    path: path.allowedAttributes,
    pre: pre.allowedAttributes,
    circle: circle.allowedAttributes,
}

// TODO: remove this legacyTags when the content is full migrated
const legacyTags = [ 'basic-copy-component', 'cta-block-component', 'external-promo-component', 'hero-component', 'image-component', 'link-component', 'page-component' ];
const tags = [ 'iframe', 'button', 'svg', 'path', 'img', 'circle', ...legacyTags];

const styles = {
    '*': {
        'background-color': [ 
            /^#(0x)?[0-9a-f]+$/i, 
            /^rgb\(\d+\, *\d+\, *\d+ *\)$/,
        ],
        'background': [
            /^linear-gradient\((.+)\)$/i,
        ]
    }
};

const iframeDomains = ['youtu.be', 'youtube.com'];

const allowVulnerableTags = true;

export default {
    attributes,
    tags,
    styles,
    iframeDomains,
    allowVulnerableTags
};
